module.exports = __webpack_public_path__ + "img/selected6-min.623aa0a4.png";